













import { defineNuxtComponent, PropType } from '~/utils/nuxt3-migration'

export default defineNuxtComponent({
  props: {
    position: {
      type: String as PropType<'right' | undefined>,
      default: undefined
    }
  }
})
